// extracted by mini-css-extract-plugin
export default {"report":"SalecByCustomer_report__E8Ot1","report-header":"SalecByCustomer_report-header__3poYT"};